import BaseModelAPI from '../BaseModelAPI';

export default class ContractStatus extends BaseModelAPI {
	static entity = 'contractstatus';
	static entityName = 'contractstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}